/**
 * LegacyWorkspaceSettingsRedirect — maps the retired Tenant Control Center
 * URLs onto the settings shell (Postel: redirects keep the click contract).
 * The ?tab= value selects the section; every OTHER search param is
 * preserved verbatim (the Google Ads OAuth callback lands here with
 * google_ads_connected=1 and the destination section must still see it).
 */

import { Navigate, useSearchParams } from 'react-router-dom';

const TAB_TO_SECTION: Record<string, string> = {
  basic: '/settings',
  location: '/settings',
  integrations: '/settings/integrations',
  media: '/settings/media',
  publishing: '/settings/website',
  indexing: '/settings/website',
  advanced: '/settings',
};

export function LegacyWorkspaceSettingsRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') ?? 'basic';
  const target = TAB_TO_SECTION[tab] ?? '/settings';

  const rest = new URLSearchParams(searchParams);
  rest.delete('tab');
  const qs = rest.toString();

  return <Navigate to={{ pathname: target, search: qs ? `?${qs}` : '' }} replace />;
}
